"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvidersImportPreview = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const router_1 = require("client/components/router");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const store_1 = require("client/modules/providers/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const button_1 = require("../../../../components/material/button");
require("./providers-import-preview.less");
const core_1 = require("@material-ui/core");
let ProvidersImportPreview = class ProvidersImportPreview extends react_1.Component {
    constructor() {
        super(...arguments);
        this.showConfirmationModal = false;
        this.loadingSaving = false;
        this.getParsedProviders = async () => {
            // if (providersStore.importedFileAndSiteId) {
            //   const accepted = providersStore.importedFileAndSiteId.accepted;
            //   const siteId = providersStore.importedFileAndSiteId.siteId;
            //   this.loadingSaving = true;
            //   await providersStore.parse(accepted, siteId.toString());
            //   this.loadingSaving = false;
            //   // const providers = providersStore.parsedProviders.providers.slice(
            //   //   Number(providersStore.selectedRowIndex),
            //   // );
            //   const importedProviders = providersStore.importedProviders;
            //   console.log("importedProviders is ", toJS(importedProviders));
            //   // console.log('providers is ', toJS(providers));
            //   // get the new patients refactored through the data mapping
            //   this.providersToPersist = importedProviders.map(
            //     (provider: any, index: number) => {
            //       const newProvider: Partial<IProvider> | any = {};
            //       for (const key in provider) {
            //         if (provider[this.mappedHeadersObject[key]] !== undefined) {
            //           newProvider[key] = provider[this.mappedHeadersObject[key]];
            //         } else {
            //           newProvider[key] =
            //             importedProviders[index][this.mappedHeadersObject[key]];
            //         }
            //       }
            //       return newProvider;
            //     }
            //   );
            // }
            const importedOrders = store_1.providersStore.importedProviders;
            // console.log("importedOrders is ", importedOrders);
            this.providersToPersist = importedOrders.map((order) => {
                const newProvider = {};
                // @tkay
                store_1.providersStore.dbHeaders.forEach(key => {
                    newProvider[key] = this.mappedHeadersObject[key]
                        ? order[this.mappedHeadersObject[key]]
                        : "";
                });
                return newProvider;
            });
        };
        this.handleOnConfirmation = () => {
            this.showConfirmationModal = true;
        };
        this.handleSubmitReview = () => {
            this.showConfirmationModal = false;
            this.loadingSaving = true;
            const { siteId } = store_1.providersStore.importedFileAndSiteId;
            store_1.providersStore
                .submitUserMappedProviderHeader(this.providersToPersist, siteId.toString())
                .then(() => {
                this.loadingSaving = false;
                router_1.RouteManager.transitionTo("/providers");
            });
        };
        this.handleOnCancel = () => {
            // console.log("handleOnCancel triggered");
        };
        this.renderTableRow = (row, i) => (React.createElement(core_1.TableRow, { className: `select-header-table__row`, key: i }, row.map((cell, i) => (React.createElement(core_1.TableCell, { className: "select-header-table__row--cell", key: i }, cell)))));
        this.renderPreview = () => {
            const providerRowsArray = this.providersToPersist.map((provider) => {
                // console.log("provider is ", provider);
                const data = [];
                for (const prop in provider) {
                    if (provider.hasOwnProperty(prop)) {
                        data.push(provider[prop]);
                    }
                }
                return data;
            });
            // console.log("providerRowsArray is ", providerRowsArray);
            // prepend header
            const headers = [];
            for (const prop in this.providersToPersist[0]) {
                if (this.providersToPersist[0].hasOwnProperty(prop)) {
                    headers.push(prop);
                }
            }
            providerRowsArray.unshift(headers);
            return providerRowsArray.map((row, i) => this.renderTableRow(row, i));
        };
    }
    componentWillMount() {
        this.mappedHeadersObject = store_1.providersStore.mappedHeadersObject || {};
        this.getParsedProviders();
    }
    componentWillUnmount() {
        store_1.providersStore.reset();
    }
    render() {
        return (React.createElement(react_1.Fragment, null,
            React.createElement("section", { className: "header-container--select" },
                React.createElement("div", { className: "header-paper--select" },
                    React.createElement("div", { className: "header-paper__message" },
                        React.createElement("h1", null, "Please review the data"),
                        React.createElement("div", null,
                            React.createElement(button_1.MaterialButton, { onClick: this.handleOnCancel, to: "/providers/import/map" }, "Back"),
                            React.createElement(button_1.MaterialButton, { disabled: this.loadingSaving, primary: true, onClick: this.handleOnConfirmation }, "confirm"))),
                    this.providersToPersist && (React.createElement(core_1.Table, { className: "select-header-table" },
                        React.createElement(core_1.TableBody, null, this.providersToPersist && this.renderPreview()))))),
            this.loadingSaving && (React.createElement("div", { className: "header-container--select__loading-bg" },
                React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "header-container--select__loading-indicator" }))),
            this.showConfirmationModal && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Submit", cancelText: "Back to review", message: `Please review the mapped table. If you are satisfied with the mapping, please submit.`, onCancel: () => (this.showConfirmationModal = false), onConfirm: this.handleSubmitReview, title: "Review confirmation" }))));
    }
};
__decorate([
    mobx_1.observable
], ProvidersImportPreview.prototype, "showConfirmationModal", void 0);
__decorate([
    mobx_1.observable
], ProvidersImportPreview.prototype, "loadingSaving", void 0);
__decorate([
    mobx_1.observable
], ProvidersImportPreview.prototype, "mappedHeadersObject", void 0);
__decorate([
    mobx_1.observable
], ProvidersImportPreview.prototype, "providersToPersist", void 0);
ProvidersImportPreview = __decorate([
    mobx_react_1.observer
], ProvidersImportPreview);
exports.ProvidersImportPreview = ProvidersImportPreview;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/providers/modules/providers-import-preview/providers-import-preview.tsx
// module id = 3846
// module chunks = 0